import Tooltip from '../../../../../../../../common/_custom/Tooltip/Tooltip';
import { infoToolTip } from '../../../../../../../../assets/hostedassets';
import AIText from '../../../../../../../../common/AIText/AIText';
import { HEADER_TYPE } from '../../../../../../../../store/dashboard/auditedFinancials/constants';
import { isAnnualisedPartialHeader, getAnnualisedFyLabel, getAnnualisedTooltipText } from '../../annualisedHeader';
import { ANNUALISED_HEADER_TOOLTIP_ALT } from '../../constants';
import type { FinancialMetricsHeaderCellProps } from '../../types';
import styles from '../../FinancialMetrics.module.scss';

function FinancialMetricsHeaderCell({ header, isPDFReport, isMobile }: FinancialMetricsHeaderCellProps) {
    if (isPDFReport) return <>{header?.name ?? ''}</>;
    if (isAnnualisedPartialHeader(header)) {
        const tooltipText = getAnnualisedTooltipText(header?.dataAvailableTill);
        return (
            <span className={styles.AnnualisedHeaderCell}>
                <AIText text={getAnnualisedFyLabel(header)} animate={false} />
                {tooltipText && (
                    <Tooltip
                        content={tooltipText}
                        direction="bottom"
                        usePortal
                        triggerOnClick={isMobile}
                        wrapperClassName={isMobile ? styles.MobileTapArea : undefined}
                    >
                        <img src={infoToolTip} height={'14px'} alt={ANNUALISED_HEADER_TOOLTIP_ALT} />
                    </Tooltip>
                )}
            </span>
        );
    }
    if (header?.type === HEADER_TYPE.PROVISIONAL_FINANCIALS) {
        return (
            <AIText
                text={(header?.name ?? '') + '*'}
                animate={false}
                style={{ display: 'block', width: '100%', textAlign: 'inherit', whiteSpace: 'nowrap' }}
            />
        );
    }
    return <>{header?.name ?? ''}</>;
}

export default FinancialMetricsHeaderCell;
